import { ca } from '@cian/analytics';

import { getNewbuildingProduct } from '../../utils/analytics';
import { IPromoInfo } from '../../types/newbuilding/promoInfo';
import { IPromoIdExtraObject } from '../../types/analytics';

export function trackPromoOffersShow(promos: IPromoInfo[], newbuildingId: number) {
  const promoId: IPromoIdExtraObject[] = promos.map((promo, index) => ({
    promo_type: promo.promoType,
    promo_id: promo.promoId,
    position: index + 1,
  }));

  ca('eventSite', {
    action: 'show_sopr',
    category: 'Promo',
    label: 'promo_offers',
    name: 'oldevent',
    products: [getNewbuildingProduct({ newbuildingId, extra: { promoId } })],
  });
}
